import { Controller } from "../../lib/stimulus-shim"

export default class extends Controller {
  static targets = ["form", "senderName", "senderEmail", "subject", "body", "submitButton", "feedback", "honeypot"]
  static values = {
    pageModuleId: Number,
    successMessage: String
  }

  submit(event) {
    event.preventDefault()

    const senderName = this.senderNameTarget.value.trim()
    const senderEmail = this.senderEmailTarget.value.trim()
    const body = this.bodyTarget.value.trim()

    if (!senderName || !senderEmail || !body) return

    this.setLoading(true)
    this.clearFeedback()

    const payload = {
      page_module_id: this.pageModuleIdValue,
        profile_id: document.querySelector('[data-profile-id]')?.dataset.profileId,
      sender_name: senderName,
      sender_email: senderEmail,
      body: body
    }

    if (this.hasSubjectTarget && this.subjectTarget.value.trim()) {
      payload.subject = this.subjectTarget.value.trim()
    }

    // Honeypot
    if (this.hasHoneypotTarget && this.honeypotTarget.value) {
      payload.website = this.honeypotTarget.value
    }

    fetch('/api/v1/contact/messages', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': this.csrfToken
      },
      body: JSON.stringify(payload)
    })
      .then(response => response.json().then(data => ({ ok: response.ok, data })))
      .then(({ ok, data }) => {
        this.setLoading(false)

        if (ok && data.success) {
          this.showFeedback(data.message || this.successMessageValue, 'success')
          this.formTarget.reset()
          this.trackEvent('contact_form_submit_success')
        } else {
          this.showFeedback(data.message || 'Une erreur est survenue.', 'error')
        }
      })
      .catch(() => {
        this.setLoading(false)
        this.showFeedback('Erreur reseau. Veuillez reessayer.', 'error')
      })
  }

  setLoading(loading) {
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = loading
      if (loading) {
        this.submitButtonTarget.dataset.originalHtml = this.submitButtonTarget.innerHTML
        this.submitButtonTarget.innerHTML = '<span class="loading loading-spinner loading-xs"></span>'
      } else {
        this.submitButtonTarget.innerHTML = this.submitButtonTarget.dataset.originalHtml || 'Envoyer'
      }
    }
  }

  showFeedback(message, type) {
    if (!this.hasFeedbackTarget) return

    const alertClass = type === 'success' ? 'alert-success' : 'alert-error'
    this.feedbackTarget.innerHTML = `<div class="alert ${alertClass} alert-sm mt-2"><span>${message}</span></div>`
  }

  clearFeedback() {
    if (this.hasFeedbackTarget) {
      this.feedbackTarget.innerHTML = ''
    }
  }

  trackEvent(eventName, properties = {}) {
    if (typeof ahoy === 'undefined') return
    if (document.querySelector('meta[name="rho-owner"]')) return

    try {
      ahoy.track(eventName, {
        ...properties,
        page_module_id: this.pageModuleIdValue,
        profile_id: document.querySelector('[data-profile-id]')?.dataset.profileId
      })
    } catch (e) {
      console.warn('Failed to track event:', e)
    }
  }

  get csrfToken() {
    const meta = document.querySelector('meta[name="csrf-token"]')
    return meta ? meta.content : ''
  }
}
